/* ============================================================
   Mad Beauty Shop - custom behaviour
   LoliT Solutions

   Kept as one theme asset so a theme copy carries it and the
   editor cannot clear it. Everything here fails quietly if the
   element it looks for is absent.

   1. Brand search  - scopes the query to one brand on submit
   2. Slideshow     - pause on hover and focus, pause button,
                      full stop when the visitor asks for reduced motion
   ============================================================ */

(function () {
  'use strict';

  /* ---------- 1. Brand search ----------
     The visible field holds only what the customer typed. The brand
     filter is bolted on at submit time, so the placeholder stays
     readable and the URL still carries a correct search query. */

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest ? event.target.closest('[data-mad-brand-search]') : null;
      if (!form) return;

      var scope = form.getAttribute('data-scope');
      if (!scope) return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var term = input.value.trim();
      // Already scoped means the customer used the back button.
      if (term.indexOf(scope) !== -1) return;

      input.value = term ? term + ' AND ' + scope : scope;
    },
    true
  );

  /* ---------- 2. Slideshow ----------
     The theme starts Swiper inside <slideshow-component> and keeps the
     instance on the element as sliderInstance.slider. We only touch
     autoplay, never the slides themselves. */

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function labelFor(paused) {
    var lang = (document.documentElement.lang || 'de').slice(0, 2);
    var words = {
      de: ['Pausieren', 'Abspielen'],
      en: ['Pause', 'Play'],
      fr: ['Pause', 'Lecture'],
      it: ['Pausa', 'Riproduci']
    };
    var pair = words[lang] || words.de;
    return paused ? pair[1] : pair[0];
  }

  function wireSlideshow(el) {
    if (el.madWired) return;
    var instance = el.sliderInstance;
    var swiper = instance && instance.slider;
    if (!swiper || !swiper.autoplay) return;

    el.madWired = true;

    // A visitor who asked for reduced motion gets a still banner.
    if (reduced) {
      try {
        swiper.autoplay.stop();
      } catch (e) {}
      return;
    }

    var pausedByUser = false;

    function stop() {
      try {
        swiper.autoplay.stop();
      } catch (e) {}
    }
    function start() {
      if (pausedByUser) return;
      try {
        swiper.autoplay.start();
      } catch (e) {}
    }

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    // Visible control, so the banner is never a trap.
    var controls = el.querySelector('.swiper-controls');
    if (!controls) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mad-slideshow__toggle';
    btn.setAttribute('aria-label', labelFor(false));
    btn.setAttribute('data-paused', 'false');
    btn.innerHTML =
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<rect class="mad-ico-pause" x="6" y="4" width="3" height="12" rx="1"></rect>' +
      '<rect class="mad-ico-pause" x="11" y="4" width="3" height="12" rx="1"></rect>' +
      '<path class="mad-ico-play" d="M7 4.5v11l9-5.5z"></path>' +
      '</svg>';

    btn.addEventListener('click', function () {
      pausedByUser = !pausedByUser;
      btn.setAttribute('data-paused', pausedByUser ? 'true' : 'false');
      btn.setAttribute('aria-label', labelFor(pausedByUser));
      if (pausedByUser) {
        stop();
      } else {
        try {
          swiper.autoplay.start();
        } catch (e) {}
      }
    });

    controls.appendChild(btn);
  }

  function scanSlideshows() {
    var nodes = document.querySelectorAll('slideshow-component[data-autoplay]');
    var pending = 0;
    for (var i = 0; i < nodes.length; i++) {
      wireSlideshow(nodes[i]);
      if (!nodes[i].madWired) pending++;
    }
    return pending;
  }

  // Swiper starts after this script, so poll briefly rather than guess.
  var tries = 0;
  var timer = setInterval(function () {
    var pending = scanSlideshows();
    tries++;
    if (pending === 0 || tries > 40) clearInterval(timer);
  }, 250);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(scanSlideshows, 300);
  });
})();
